<template>
<div>
    <el-dialog title="事件详情" custom-class="accident-dialog" :close-on-click-modal="false" :modal-append-to-body="false" 
        :visible="dialogVisible" @close="close" width="800px" >
        <div slot='title' class="slotitle">
            <span class="name">事件详情</span><span class="code">编号：{{infomation.code}}</span>
        </div>
        <div class="container" v-loading="status === 'loading'" v-if="status === 'loading'"></div>
        <div class="container" v-else>
            <div class="infomation">
                <div class="title">
                    <img src="../../../assets/img/error-green.png" alt="" v-if="infomation.incident_classification=='notice'"> 
                    <img src="../../../assets/img/error-red.png" alt="" v-else-if="infomation.incident_classification=='urgent'">
                    <img src="../../../assets/img/error-yellow1.png" alt="" v-else-if="infomation.incident_classification=='hiddenDanger'">
                    <div class="name">
                        {{infomation.name}}<br>
                        <span v-if="infomation.type">{{infomation.type}}</span>
                        <span v-else>{{infomation.classify | mapper1}}</span>
                    </div>
                    <div class="devices" @click="deviceDetail">设备参数</div>
                </div>
                <div class="cont">
                    <div class="description">
                        <div class="data-title">基本信息</div>
                        <div class="description-content" id="accidentRadio">
                            <div>事件分类：{{infomation.incident_type | mapper}}</div>
                            <div>站点信息：{{infomation.position}}</div>
                            <div>发生时间：{{infomation.start | dateFormat}}</div>
                            <div>结束时间：{{infomation.end | dateFormat}}</div>
                            <div v-if="infomation.check !== undefined">确认状态：
                                <el-radio disabled v-model="radio" label='false' @change="change">未确认</el-radio>
                                <el-radio v-model="radio" label='true' @change="change" class="green" style="margin-right:0px">已确认</el-radio>
                                <span v-if="infomation.check && showName">(确认人：{{infomation.realName}})</span>
                            </div>
                        </div>
                    </div>
                    <div class="data" v-if="data.length > 0">
                        <div class="data-title">事件诊断：</div>
                        <!-- <div class="warm">A相电压过高引起跳闸</div> -->
                        <div class="data-content">
                            <Transformer v-for="(item, index) in data" :key="index" :item="item"></Transformer>
                            <span class="separate"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
    
    <DeviceDetails v-if="isShowDetail"
        :dialogVisible="isShowDetail"
        :checkedDevicesDetails="checkedDevicesDetails"
        :checkedDevicesInfo="checkedDevicesInfo"
        :detailStatus="detailStatus"
        @closeDetail="closeDetail"
    ></DeviceDetails>
</div>
    
    
</template>

<script>
    import PointItem from '../shared/PointItem.vue';
    import Transformer from '../shared/transformer.vue';
    import DeviceDetails from './DeviceDetails.vue';
    import {
        dateFormat
    } from '../../../util/DateUtil';
    import {
        TYPES
    } from '../../../util/TYPES';

    const TYPES1 = {
        fault:"故障报警",
        hiddenDanger:"隐患",
        messageNotice:"信息通报",
        notice:"通知",
        operation:"操作命令",
        other:"其他",
        overrun:"越限异常",
        protections:"保护动作",
        switchDisplacement:"开关变位",
        urgent:"紧急"
    }

    export default {
        props: {
            dialogVisible: Boolean,
            status: String,
            detail: Object
        },
        data() {
            return {
                loading: false,
                changeState: false,
                showName: true,
                isShowDetail:false,
                detailStatus: 'loaded',
                // 要查看的设备的简介
                checkedDevicesInfo: '',
                // 要查看的设备的详情
                checkedDevicesDetails: '',
            }
        },
        components: {
            PointItem,
            Transformer,
            DeviceDetails
        },
        // mounted() {
        //     console.log(this.infomation)
        // },
        methods: {
            
             // 关闭对话框
            closeDetail() {
                this.isShowDetail = false;
            },
            deviceDetail(){
                // this.close();
                // this.dialogVisible = false
                this.isShowDetail = true
            },
            close() {
                this.$emit('closeDetail', this.infomation.code, this.infomation.check, this.changeState)
            },
            change(value) {
                this.detail.infomation.check = true
                this.changeState = true
                this.showName = false
            }
        },
        watch: {},
        computed: {
            infomation: function () {
                return this.detail && this.detail.infomation || {};
            },
            data: function () {
                this.checkedDevicesDetails = this.detail.infomation.device;
                this.checkedDevicesInfo = this.detail.infomation;
                return this.detail && this.detail.data || [];
            },
            radio: {
                get() {
                    return this.detail && this.detail.infomation.check.toString()
                },
                set(value) {
                    return value
                }
            }
        },
        filters: {
            mapper: function (value) {
                return TYPES1[value] || '未知事件';
            },
            mapper1: function (value) {
                return TYPES[value] || '未知事件';
            },
            dateFormat: function (value) {
                if (!value) {
                    return '--';
                }
                return dateFormat('YYYY年mm月dd日 HH:MM', new Date(value));
            }
        }
    }
</script>

<style lang="less" scoped>
    .slotitle{
        .name{
            font-size: 18rem;
            font-weight: bold;
            color: #333333;
        }
        .code{
            // position: absolute;
            // top: 0;
            // left: 100px;
            // line-height: 6.3vh;
            font-size: 16px !important;
            color: #999999 !important;
            font-weight: 400 !important;
            margin-left: 20px !important;
        }
    }
    /deep/.accident-dialog{
        margin-top: 11vh !important;
    }
    .warm{
        background: rgba(253, 66, 56, 0.06);
        border-radius: 4px;
        color: #666666;
        font-size: 16rem;
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
        margin-bottom: 20rem;
    }
    .container {
        display: flex;
        min-height: 670rem;
        flex-direction: column;
        // background: rgba(0, 43, 102, 0.02);
        background: rgba(0, 43, 102, 0.04);
    }
    /deep/ .el-dialog__body {
        border-top: 1px solid rgba(0, 0, 0, 0.1) !important
    }
    /deep/ .el-dialog__header{
        padding: 0 0 0 20rem !important;
    }
    
    .data-title{
        font-size: 16px;
        font-weight: bold;
        line-height: 19rem;
        margin: 24rem 0;
        &::before{
            content: '';
            width: 4px;
            height: 19rem;
            background: #0D94FF;  
            display: inline-block;
            vertical-align: -2px;
            margin-right: 8px;
        }
    }
    .infomation {
        // padding: 24rem;
        // display: flex;
        
        flex-direction: row;
        // .h(385);
        color: #333;
        .title{
            // display: flex;
            padding: 40rem;
            overflow: hidden;
            background: #ffffff;
            height: 152rem;
            img{
               width: 36rem;
                height: 36rem; 
                float: left;
            }
            .name{
                font-size: 24rem;
                font-weight: bold;
                margin-left:22rem ;
                float: left;
                line-height: 40rem;
                margin-top: -4px;
            }
            .devices{
                border: 1px solid #E5E5E5;
                border-radius: 2px;
                color: #666666;
                font-size: 14px;
                width: 72px;
                height: 24px;
                text-align: center;
                line-height: 24px;
                float: right;
                cursor: pointer;
            }
        }
        
        .image-wapper {
            .h(337);
            .w(360);
            border: 1px solid #EEEEEE;
            display: flex;
            flex-direction: column;
            justify-content: center;

            img {
                display: block;
                width: 300rem;
                margin: 0 auto;
            }

            div {
                text-align: center;
            }
        }
        .cont{
            padding:0  40rem 20rem 40rem;
        }
        .description {
            // .w(576);
            // background: rgba(0, 43, 102, 0.04);
            .description-title {

                div {
                    font-size: 24rem;
                    font-weight: bold;
                    color: #333333;
                }

                span {
                    font-size: 16rem;
                    font-weight: 400;
                    color: #999999;
                    margin-top: 14rem;
                    display: block;
                    margin-bottom: 24rem;
                }
            }

            .separate {
                height: 1px;
                background: rgba(0, 0, 0, 0.06)
            }

            .description-content {
                display: flex;
                flex-flow: column nowrap;

                div {
                    font-size: 16rem;
                    font-weight: 400;
                    color: #666666;
                    margin-bottom: 14rem;
                }
            }
        }
    }

    .data {
        // padding: 24rem;
        // background: rgba(0, 43, 102, 0.02);
        width: 100%;
        // .h(180);
        // height: 182px;
        .data-content {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            flex-wrap: wrap;
            // max-height: 99%;
            // width: 50%;

            // .separate {
            //     margin: 0;
            //     width: 1px;
            //     height: 132rem;
            //     background: rgba(0, 0, 0, 0.15);
            //     position: absolute;
            //     left: 48%;
            // }

        }
    }
</style>